import * as React from 'react';
import InputMask from 'react-input-mask';
import { Button, Col, Form, FormGroup, Input, Row } from 'reactstrap';
import FormFeedback from 'reactstrap/lib/FormFeedback';
import { IGlobalContextProps, withGlobalContext,} from 'src/context/global.context';
import { register, sendActivationEmail } from 'src/services';
import { isEmail, isMobilePhoneNumber , isPassword, isPhoneNumber } from 'src/utils/validation';


interface IProjectModalProps {
  changeStep: (stepNumber: number) => void;
  toggleCreateConsultantModal: () => void;
}

const CreateConsultantFirstStep: React.SFC<
  IProjectModalProps & IGlobalContextProps
> = ({ changeStep, context, toggleCreateConsultantModal }) => {
  const [state, setState] = React.useState({
    invalid: false,
    signup: {
      address: {
        mobilephone: '',
        phone: '',
      },
      email: '',
      firstname: '',
      lastname: '',
      password: '',
      type: 'consultant',
    },
  });
  const isValid =
    !!state.signup.lastname &&
    ( !!state.signup.password  &&   isPassword(state.signup.password)) &&
    (!!state.signup.address.mobilephone && isMobilePhoneNumber(state.signup.address.mobilephone)) &&
    (!!!state.signup.address.phone || isPhoneNumber(state.signup.address.phone)) ;
    
      
  const handleChange = (e: React.ChangeEvent<Element>) => {
    setState({
      invalid: false,
      signup: {
        ...state.signup,
        [(e.target as any).name]: (e.target as any).value,
      },
    });
  };

  const handleAddressChange = (e: React.ChangeEvent<Element>) => {
    setState({
      invalid: false,
      signup: {
        ...state.signup,
        address: {
          ...state.signup.address,
          [(e.target as any).name]: (e.target as any).value,
        },
      },
    });
  };

  const handleSignup = async () => {
    if (isValid) {
      try {
        const signupResponse = await register(state.signup);
        if (signupResponse) {
          context.updateUser();
          context.toggleIsCreating();

          localStorage.setItem('beadvize-IsCreating',  signupResponse.user._id );
          sendActivationEmail();

          changeStep(2);
        }
      } catch (error) {
        if (error && error.response && error.response.status === 400) {
          setState({
            ...state,
            invalid: true,
          });
        }
      }
    } else {
      setState({
        ...state,
        invalid: true,
      });
    }
  };

  return (
    <Form className='p-5'>
      <FormGroup>
        <Input
          type='text'
          name='lastname'
          placeholder='Nom*'
          invalid={state.invalid && !!!state.signup.lastname}
          value={state.signup.lastname}
          onChange={handleChange}
        />
        <FormFeedback>Merci de renseigner ce champ</FormFeedback>
      </FormGroup>
      <FormGroup>
        <Input 
          className='mt-3'
          type='text'
          name='firstname'
          placeholder='Prénom'
          value={state.signup.firstname}
          onChange={handleChange}
        />
      </FormGroup>
      <FormGroup>
        <Input
          className='mt-3'
          type='text'
          name='email'
          placeholder='E-mail*'
          invalid={(state.invalid &&  isValid)  || (state.invalid &&  !!!state.signup.email )  ||  (!!state.signup.email  && !isEmail(state.signup.email)) } 
          value={state.signup.email}
          onChange={handleChange}
        />
        <FormFeedback>
          {isEmail(state.signup.email)
            ? `Cette adresse e-mail est déjà associée à un compte`
            : `Adresse e-mail non valide`
            }  
        </FormFeedback>
      </FormGroup>
      <FormGroup>
        <Input
          className='mt-3'
          type='password'
          name='password'
          placeholder='Mot de passe*'
          invalid={(state.invalid &&  !isPassword(state.signup.password) ) ||  (!!state.signup.password && !isPassword(state.signup.password) )   }
          value={state.signup.password}
          onChange={handleChange}
        />
        <FormFeedback>
        {!state.signup.password 
            ? 'Merci de choisir un mot de pass'
            : 'Votre mot de passe doit contenir 8 caractères minimum avec au moins une majuscule, un chiffre et un caractère spécial'}
        </FormFeedback>
      </FormGroup>
      <FormGroup>
        <Input
          className='mt-3'
          type='text'
          name='mobilephone'
          placeholder='Mobile*'
          invalid={
              (state.invalid  && (!!!state.signup.address.mobilephone || !isMobilePhoneNumber(state.signup.address.mobilephone)))
              ||  (!!state.signup.address.mobilephone && !isMobilePhoneNumber(state.signup.address.mobilephone))
          }
          value={state.signup.address.mobilephone}
          onChange={handleAddressChange}
          tag={InputMask}
          mask="+3\3 9 99 99 99 99" 
          maskChar={null} 
        />
        <FormFeedback>
        {!state.signup.address.mobilephone 
            ? 'Merci de renseigner ce champ'
            : null}
        </FormFeedback>
      </FormGroup>
      <FormGroup>
        <Input
          className='mt-3'
          type='text'
          name='phone'
          placeholder='Téléphone'
          invalid={
            !!state.signup.address.phone &&
            !isPhoneNumber(state.signup.address.phone)
          }
          value={state.signup.address.phone}
          onChange={handleAddressChange}
          tag={InputMask}
          mask="+3\3 9 99 99 99 99" 
          maskChar={null} 
        />
      </FormGroup>
      <FormGroup>
        <span className='d-block mb-3'>
          * Champs obligatoires 
        </span>
      </FormGroup>
      <Row>
        <Col xs='6'>
          <Button
            className='text-uppercase text-white bg-dark border-0 mt-3'
            onClick={toggleCreateConsultantModal}
          >
            Annuler
          </Button>
        </Col>
        <Col xs='6'>
          <Button
            className='text-uppercase text-white bg-secondary float-right border-0 mt-3'
            onClick={handleSignup}
          >
            Étape 2 {'>'}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export const CreateConsultantFirstStepWithGlobalContext = withGlobalContext(
  CreateConsultantFirstStep
);



// WEBPACK FOOTER //
// ./src/components/shared/Modals/CreateConsultantModal/CreateConsultantFirstStep.tsx